// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211240/js/" + chunkId + "." + {"44":"d1b86d52","225":"9c7f0a7b","481":"9336498a","486":"1fd322a5","770":"e35bedbf"}[chunkId] + ".0.5365856343948643.chunk.js";
};